import SystemMonitoring from "../Components/SystemMonitoring/SystemMonitoring";

const HardwareMonitoringPage = () => {
  return <SystemMonitoring />;
};

export default HardwareMonitoringPage;
